import { memo, useMemo } from 'react';

import { Box, Text } from '@betty/moonlight';
import { useTranslation } from '@betty/i18n';
import { statusTextTokenMap } from '../content/status.content';
import { StatusMemberInstructionsProps } from './types';
import { StatusType } from '../state/status.types';

function StatusMemberInstructions({ status }: StatusMemberInstructionsProps) {
  const { promotionNumberOfBoxes, nextPlayerStatus } = status;
  const [t] = useTranslation('status');

  const titleLocKey = useMemo(
    () =>
      promotionNumberOfBoxes === 1
        ? 'member_instructions_title_one'
        : 'member_instructions_title_other',
    [promotionNumberOfBoxes],
  );

  const textGradientToken = useMemo(
    () => statusTextTokenMap[nextPlayerStatus as StatusType],
    [nextPlayerStatus],
  );

  return (
    <Box
      flex={1}
      gap="space-400"
      backgroundColor="mutedBackground"
      alignItems="center"
      padding="space-300"
      borderRadius="radius-200"
    >
      <Box>
        <Text
          variant="caption"
          locNS="status"
          color="darkSurfaceTertiary"
          locKey="member_instructions_title_one"
          textAlign="center"
        >
          {t(titleLocKey, { numberOfBoxes: promotionNumberOfBoxes })}
        </Text>
        <Text
          variant="caption-semi"
          locNS="status"
          gradient={textGradientToken}
          locKey={nextPlayerStatus}
          textAlign="center"
        />
      </Box>
      <Text variant="caption" color="darkSurfaceTertiary" textAlign="center">
        {t('member_instructions_message', { nextStatus: nextPlayerStatus })}
      </Text>
    </Box>
  );
}

export default memo(StatusMemberInstructions);
